var _style, _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLineDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "9.7px",
    height: "53.5px",
    viewBox: "0 0 9.7 53.5",
    style: {
      enableBackground: "new 0 0 9.7 53.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DB7341;}\n\t.st1{fill:none;stroke:#DB7341;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.8,47.5c0-0.5,0.5-1,1-1l0,0c0.6,0,1,0.5,1,1l0,0c0,0.5-0.4,1-1,1l0,0C4.3,48.5,3.8,48.1,3.8,47.5z M3.8,42.5 c0-0.6,0.5-1,1-1l0,0c0.6,0,1,0.4,1,1l0,0c0,0.5-0.4,1-1,1l0,0C4.3,43.5,3.8,43.1,3.8,42.5z M3.8,37.5c0-0.5,0.5-1,1-1l0,0 c0.6,0,1,0.5,1,1l0,0c0,0.5-0.4,1-1,1l0,0C4.3,38.5,3.8,38.1,3.8,37.5z M3.8,32.5c0-0.5,0.5-1,1-1l0,0c0.6,0,1,0.5,1,1l0,0 c0,0.5-0.4,1-1,1l0,0C4.3,33.5,3.8,33.1,3.8,32.5z M3.8,27.5c0-0.5,0.5-1,1-1l0,0c0.6,0,1,0.5,1,1l0,0c0,0.6-0.4,1-1,1l0,0 C4.3,28.5,3.8,28.1,3.8,27.5z M3.8,22.5c0-0.5,0.5-1,1-1l0,0c0.6,0,1,0.5,1,1l0,0c0,0.6-0.4,1-1,1l0,0C4.3,23.5,3.8,23.1,3.8,22.5z  M3.8,17.5c0-0.5,0.5-1,1-1l0,0c0.6,0,1,0.5,1,1l0,0c0,0.6-0.4,1-1,1l0,0C4.3,18.5,3.8,18.1,3.8,17.5z M3.8,12.5c0-0.5,0.5-1,1-1 l0,0c0.6,0,1,0.5,1,1l0,0c0,0.6-0.4,1-1,1l0,0C4.3,13.5,3.8,13.1,3.8,12.5z M3.8,7.5c0-0.5,0.5-1,1-1l0,0c0.6,0,1,0.5,1,1l0,0 c0,0.6-0.4,1-1,1l0,0C4.3,8.5,3.8,8.1,3.8,7.5z M3.8,2.5c0-0.5,0.5-1,1-1l0,0c0.6,0,1,0.5,1,1l0,0c0,0.6-0.4,1-1,1l0,0 C4.3,3.5,3.8,3.1,3.8,2.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    className: "st0",
    cx: 4.8,
    cy: 2,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    className: "st1",
    d: "M0.3,48.9l4.5,4l4.5-4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLineDown);
export default __webpack_public_path__ + "static/media/arrow-line-down.c0e7d724a331b06fd8f6e7d9f00681eb.svg";
export { ForwardRef as ReactComponent };